// AGC: Staking Summary Dashboard Widget
// AGC: Shows quick overview of staking stats on Home page

import React from 'react'
import { Coins, ArrowRight, TrendingUp, Users } from 'lucide-react'
import { useStaking } from '../../hooks/useStaking'
import { formatEther } from 'viem'

interface StakingSummaryProps {
  onViewDetails: () => void
}

export const StakingSummary: React.FC<StakingSummaryProps> = ({ onViewDetails }) => {
  // AGC: Fetch real staking data from contract
  const { stats } = useStaking()

  // AGC: Format number helper
  const formatNumber = (value: bigint, decimals: number = 2) => {
    return Number(formatEther(value)).toFixed(decimals)
  }

  const totalStaked = formatNumber(stats.totalStaked)
  const yourStake = formatNumber(stats.yourStake)

  return (
    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/50 h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold flex items-center gap-2">
          <Coins className="w-5 h-5 text-[#0072CE]" />
          Staking Overview
        </h3>
        <button
          onClick={onViewDetails}
          className="text-xs text-[#0072CE] hover:text-[#0088e6] flex items-center gap-1"
        >
          View Details <ArrowRight className="w-3 h-3" />
        </button>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">Total Staked</span>
          <span className="text-white font-semibold">{totalStaked} OGB</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">Your Stake</span>
          <span className="text-white font-semibold flex items-center gap-1">
            <Users className="w-3 h-3 text-slate-500" />
            {yourStake} OGB
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">Revenue Share</span>
          <span className="text-[#0072CE] font-semibold flex items-center gap-1">
            <TrendingUp className="w-3 h-3" />
            50%
          </span>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-slate-700/50">
        <button
          onClick={onViewDetails}
          className="w-full py-2 bg-[#005a9e]/20 hover:bg-[#005a9e]/30 text-[#0072CE] rounded-lg text-sm font-medium transition-colors"
        >
          Stake Now
        </button>
      </div>
    </div>
  )
}

